import { Column, SemanticModel } from "@pufflig/prompt-studio-types";
import { saveSemanticModel } from "../../actions/saveSemanticModel";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const updateColumn = async (connectorId: string, updated: Column) => {
  const { semanticModel, selectedTable, dbSchema } = useSemanticModelStore.getState();
  if (!semanticModel || !selectedTable) return;

  const [schemaName, tableName] = selectedTable.split(".");
  const existing = semanticModel.schemas?.[schemaName]?.tables?.[tableName]?.columns || [];
  const newColumns = existing.map((c) => (c.columnName === updated.columnName ? updated : c));

  const newSemanticModel: SemanticModel = {
    ...semanticModel,
    schemas: {
      ...semanticModel.schemas,
      [schemaName]: {
        ...(semanticModel.schemas?.[schemaName] || { tables: {} }),
        tables: {
          ...(semanticModel.schemas?.[schemaName]?.tables || {}),
          [tableName]: {
            ...(semanticModel.schemas?.[schemaName]?.tables?.[tableName] || { columns: [] }),
            columns: newColumns,
          },
        },
      },
    },
  };

  const connectorColumns = dbSchema?.schemas?.[schemaName]?.tables?.[tableName]?.columns || [];
  const merged = connectorColumns.map((c) => {
    const m = newColumns.find((mc) => mc.columnName === c.columnName);
    return { ...c, ...(m || {}), hidden: !m } as Column;
  });

  useSemanticModelStore.setState(
    (state) => {
      state.semanticModel = newSemanticModel;
      state.selectedTableSchema = merged;
    },
    false,
    "column/update_semantic_model",
  );

  await saveSemanticModel(connectorId, newSemanticModel);
};
